import { render, staticRenderFns } from "./caseDetailss.vue?vue&type=template&id=6999e0b6&scoped=true&"
import script from "./caseDetailss.vue?vue&type=script&lang=js&"
export * from "./caseDetailss.vue?vue&type=script&lang=js&"
import style0 from "./caseDetailss.vue?vue&type=style&index=0&id=6999e0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999e0b6",
  null
  
)

export default component.exports